const mfl_events_list = [
	'Colapso Estructural',
	'Desgaste ',
	'Falla Eléctrica',
	'Falla Estructural',
	'Falla Mec-Estruc',
	'Falla Mecá-Estructural',
	'Falla Mecánica',
	'Falla estructural',
	'Falla sistema motriz',
	'Impacto de tren en estación de descarga.',
	'Incendio',
	'Incendio ',
	'Incendio en gabinetes DCS',
	'Rotura de Cajón',
	'Rotura de Geomembrana'
];

const asset = {
	simulation_status:null,
	bowtie:[],
	pre_discharged:false,
	name: '',
	mfl_event: '',
	ebit: 0,
	impact_percentage: 0,
	mfl_days: null,
	mfl_health_and_safety: 0,
	mfl_environment: 0,
	mfl_community: 0,
	mfl_legal: 0,
	mfl_reputation: 0,
	mfl_sustainability: 0,
	mfl_financial: 0,
	global_risk_standard_version: 2,
	residual_scene: '',
	health_and_safety_residual: 0,
	environment_residual: 0,
	community_residual: 0,
	sustainability_residual: 0,
	legal_residual: 0,
	reputation_residual: 0,
	severity: 0,
	posibility: 0.0,
	rrr: 0,
	organization: '',
	standard: [], // no se donde es
	speciality: '',
	impacted_areas: [],
	computed_financial_mfl: 0,
	computed_financial_residual: 0,
	financial_residual: 0,
	redundant: false,
	discharge_date: null,
	n_1: false,
	r_impact_percentage: 0, // sin relacion
	/* r_detention_days_by_mfl: null, // sin relacion */
	has_spare: false,
	residual_days: null,
	spare_part_type: null,
	critical_asset:[],
	function_location_array: [''],
	material_number:[''],
	asset_class_name:null,
	tag:null,
	discharge_files:[],
	discharge_message:null,
	discharge_trigger_user:null,
	/* critical_asset_simulation:null, */
	id:null,
	from_simulation:false,
	impact_percentage_justification :null,
	state:null,
	photographic_record:[],
}
const mflTitle = {
	mfl_health_and_safety: 'MFL Salud y Seguridad',
	mfl_environment: 'MFL Medioambiente',
	mfl_community: 'MFL Comunidad',
	mfl_legal: 'MFL Reputación / Legal',
	//mfl_reputation: 'MFL Reputación',
	mfl_financial: 'MFL Financiero',

	health_and_safety_residual: 'Residual de salud y seguridad',
	environment_residual: 'Residual de medioambiental',
	community_residual: 'Residual de comunidad',
	legal_residual: 'Residual Reputación / Legal',
	//reputation_residual: 'Residual de reputación',
	financial_residual: 'Residual financiero',	
}
const mflKeys = [
	'health_and_safety_residual',
	'mfl_health_and_safety',
	'environment_residual',
	'mfl_environment',
	'community_residual',
	'mfl_community',
	'legal_residual',
	'mfl_legal',
	'reputation_residual',
	'mfl_reputation',
	'financial_residual',
	'mfl_financial',
	]
const SXP_titles = { nivel:'Nivel de descriptor',descriptor:'Descriptor',factor:'Factor de severidad'}
const SXP_values = [
	{nivel:5,descriptor:'6 o más fatalidades, o 6 o más enfermedades que acortan la vida.',factor:1000},
	{nivel:4,descriptor:'1-5 fatalidades o 1-5 enfermedades que acortan la vida.',factor:300},
	{nivel:3,descriptor:'Incapacidad permanente/de largo plazo, o lesión o enfermedad que altere la vida de una o más personas.',factor:100},
	{nivel:2,descriptor:'Lesión o enfermedad que no altera la vida, o de corto plazo de una o más personas.',factor:30},
	{nivel:1,descriptor:'Impactos de bajo nivel que solo requieren primeros auxilios.',factor:10},
];

const likelihood_titles = { nivel:'Nivel',descriptor:'Frecuencia',factor:'Factor de severidad'}

const likelihood_values = [
	{nivel:'Altamente probable (Highly Likely)',descriptor:'La falla ocurre dentro de un periodo de 1 año',factor:3},
	{nivel:'Probable (Likely)',descriptor:'La falla ocurre dentro de un periodo de 2 años',factor:1},
	{nivel:'Probable (Probable)',descriptor:'La falla ocurre dentro de un periodo de 5 años',factor:(0.3)},
	{nivel:'Improbable (Unlikely)',descriptor:'La falla ocurre dentro de un periodo de 20 años',factor:(0.1)},
	{nivel:'Altamente improbable (Highly Unlikely)',descriptor:'La falla ocurre dentro de un periodo de 50 años',factor:(0.03)},
];
/* const priority_mtx = [
	[4,3,2,1,1],
	[5,4,3,2,1],
	[5,5,4,3,2],
	[5,5,5,4,3],
	[5,5,5,5,4],
]; */
const priority_mtx = [
	[4,3,2,1,1],
	[4,4,3,2,1],
	[4,4,4,3,2],
	[4,4,4,4,3],
	[4,4,4,4,4],
];
const impact_types = [
	{id:'health_and_safety',name:'Salud y seguridad'},
	{id:'environment',name:'Medioambiente'},
	{id:'community',name:'Social y cultural'},
	{id:'legal',name:'Reputación / Legal'},
	/* {id:'reputation',name:'Reputación'}, */
	{id:'financial',name:'Financiero'},
];
const finding = {
	id:null,
	finding_creation_date:null,
	creation_date: null,
	critical_asset: null,
	description: null,
	notification_type: null,
	sap_number: null,
	inspection_place: null,
	inspection_date: null,
	report_date: null,
	speciality: null,
	severity: null,
	likelihood: null,
	rrr: null,
	priority: null,
	technical_background: null,
	inspection_goal: null,
	inspection_methodology: null,
	inspection_development: null,
	documents: [],
	recomendation: null,
	photographic_record: [],
	participants: [],
	preview : {files:[],srcs:[]},
	loadingFiles: [],
	/*  */
	computed_financial_mfl:null,
	mfl_days:null,
	comment:null,
	impact_type:null,
	mfl_health_and_safety:null,
	mfl_environment:null,
	mfl_community:null,
	mfl_legal:null,
	mfl_reputation:null,
	mfl_sustainability:null,
	mfl_financial:null,
	global_risk_standard_version: 2,
	technical_report:null,
	process:null,
	responsible: [],
	standard:null,
	parent_finding_code:null,
	notebook_code:'',
	npi_cho_specification:null,
	ebit:null,
	created:undefined,
	sap_notice_number:null,
	sap_ot_number:null,
	sap_notice_number_status:null,
	sap_ot_number_status:null,
	impact_percentage:null,
	notify_ot_inspection_number:null,
	sap_notice_inspection_number:null,
	sap_ot_inspection_number:null,
	remediation_status:null,
	inspection_dates:[],
	lat:null,
	lng:null,
}
const asset_status = {
	names: ['Revisión', 'Rechazado', 'Aprobado', null, null, 'Revisión a Histórico Desactivado'],
	color: ['yellow', 'red', 'green', null, null, 'orange'],
};
const due_date_status_list = [
	{name:'Caducado',value:'expired'},
	{name:'1 mes por vencer',value:'1mm'},
	{name:'3 meses por vencer',value:'3mm'},
	{name:'Vigente',value:'current'}
];
const action_steps_info = {
	finding_data:{step:1, name: 'Identificación de un Hallazgo'},
	remediation_data:{step:2,name:'Plan de Remediación'},
	remediation_tracking_data:{step:3, name:'Seguimiento del Plan de Remediación'},
	closing_remediation_data:{step:4, name: 'Cierre Técnico'},
	/* closing_action_data:{step:5, name: 'Cierre del Hallazgo'}, */
};
const remediation_status = [
	{id:0,name:'Selección / Definición'},
	{id:1,name:'Iniciación'},
	{id:2,name:'Comisionamiento'},
	{id:3,name:'Planificación'},
	{id:4,name:'Ejecución'},
	{id:5,name:'En definición'},
	{id:12,name:'En definición – TS'},
	{id:10,name:'Monitoreado'},
	{id:11,name:'No monitoreado'},
	{id:6,name:'Cierre provisorio'},
	{id:7,name:'Validación Cierre Hallazgo'},
	{id:8,name:'Revisión Cierre'},
	{id:9,name:'Cierre final'},
];
const priority_colors = {P1:'priority_color_mapping_p1',P2:'priority_color_mapping_p2',P3:'priority_color_mapping_p3',P4:'priority_color_mapping_p4',P5:'priority_color_mapping_p5'};
const technical_reports = [
	'Cálculos Finitos',
	'Inspección estructural ASI','Verificación SPCI',
	'Engineering Assessment',
	'Proyecto',
	'Inspección no estructural ASI',
	'Soporte Técnico'
];
const count_findings = {
	'01':{label:'Cierre Provisorio mayor o igual a 1 mes',filter:{
		ae__remediationactions__state:'6',
		f__monthly_remediation_last_state:'1'
	}},
	'02':{label:'P4 sin monitoreo mayor o igual a 1 mes',filter:{
		ae__priority:'P4',
		ae__remediationactions__state:'11',
		f__monthly_remediation_last_state:'1'
	}},
	'03':{label:'P3 en estatus En Definición mayor o igual a 3 meses',filter:{
		ae__priority:'P3',    
		ae__remediationactions__state:'0,5,12',
		f__monthly_remediation_last_state:'3'
	}},
	'04':{label:'P2 en estatus En Definición mayor o igual a 1 mes',filter:{
		ae__priority:'P2',
		ae__remediationactions__state:'0,5,12',
		f__monthly_remediation_last_state:'1',
	}},
	'05':{label:'Hallazgos vencidos',filter:{
		f__expired_remediation_date:'true',
	}},
	'06':{label:'Hallazgos vencidos sin prórroga',filter:{
		f__expired_remediation_date:'true',
		f__remediation_with_extension:'false',
	}},
	'07':{label:'Hallazgos con MII abiertas versus hallazgos cerrados',filter:{
		ae__remediationactions__state:'9',
		f__has_temporary_engineering_measures:'true',
		f__temporary_engineering_measures_status:'opened',
	}},
	'08':{label:'Hallazgos P1, P2 y P3 sin información de Aviso Remediación - OPEX',filter:{
		ae__priority:'P1,P2,P3',
		f__empty_remediation_sap_notice_number:'true',
		remediationactions__project_type:'OPEX',
	}},
	'09':{label:'Hallazgos P1, P2 y P3 sin información de Aviso Remediación - CAPEX',filter:{
		ae__priority:'P1,P2,P3',
		f__empty_remediation_sap_notice_number:'true',
		remediationactions__project_type:'CAPEX',
	}},
	'10':{label:'Hallazgos con MII en status Abierto',filter:{
		f__has_temporary_engineering_measures:'true',
		f__temporary_engineering_measures_status:'opened',
	}},
	'11':{label:'Hallazgos con Verificaciones MII Vencidas',filter:{
		f__findings_with_overdue_temv:'true',
	}},
	'12':{label:'Hallazgos P2 Abiertos con MII ausentes',filter:{
		ae__priority:'P2',
		f__has_temporary_engineering_measures:'true',
		f__summarized_finding_state:'opened',
	}},
	'13':{label:'Hallazgos Abiertos a vencer - 120 días del vencimiento',filter:{
		f__summarized_finding_state:'opened',
		f__finding_close_to_due:'true',
	}},
};
const spci = {
	status:null,
	id:null,
	bcei:null,
	description:null,
	brand:null,
	model:null,
	functional_location:null,
	maintenance_plan_id:null,
	maintenance_item_id:null,
}
export {
	spci,
	count_findings,
	technical_reports,
	priority_colors,
	remediation_status,
	action_steps_info,
	due_date_status_list,
	asset_status,
	finding,
	impact_types,
	priority_mtx,
	likelihood_values,
	likelihood_titles,
	SXP_titles,
	SXP_values,
	asset,
	mfl_events_list,
	mflTitle,
	mflKeys,
}
